// extracted by mini-css-extract-plugin
export default {"item":"text-block-module__item___l_jF4","title":"text-block-module__title___XlsGQ"};